import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi';
import { TESTIMONIALS } from '../data';

export default function Testimonials() {
  const [cur, setCur]     = useState(0);
  const [dir, setDir]     = useState(1);
  const go = (d) => { setDir(d); setCur(c => (c + d + TESTIMONIALS.length) % TESTIMONIALS.length); };
  const t = TESTIMONIALS[cur];

  return (
    <section className="section-pad relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-violet-950/8 to-transparent pointer-events-none" />
      <div className="max-w-5xl mx-auto px-6">

        {/* Header */}
        <motion.div initial={{opacity:0,y:28}} whileInView={{opacity:1,y:0}}
          transition={{duration:0.55}} viewport={{once:true}} className="text-center mb-16">
          <p className="text-violet-400 font-mono text-xs tracking-[0.2em] uppercase mb-4">— Client Feedback</p>
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            What Clients <span className="grad-text">Say</span>
          </h2>
        </motion.div>

        {/* Carousel */}
        <AnimatePresence mode="wait" custom={dir}>
          <motion.div key={cur}
            custom={dir}
            initial={{opacity:0,x:dir*50}} animate={{opacity:1,x:0}} exit={{opacity:0,x:-dir*50}}
            transition={{duration:0.38,ease:'easeOut'}}
            className="glass rounded-3xl p-10 border border-white/[0.06] text-center"
          >
            <FaQuoteLeft className="text-violet-500/25 text-5xl mx-auto mb-8" />
            <p className="text-slate-300 text-lg sm:text-xl leading-relaxed max-w-2xl mx-auto mb-10 italic">
              "{t.text}"
            </p>
            <div className="flex justify-center gap-1 mb-6">
              {[...Array(t.rating)].map((_,i) => <FaStar key={i} className="text-amber-400" size={15}/>)}
            </div>
            <div className="flex items-center justify-center gap-4">
              <div className={`w-14 h-14 rounded-full bg-gradient-to-br ${t.grad} flex items-center justify-center font-bold text-white text-lg`}>
                {t.init}
              </div>
              <div className="text-left">
                <p className="text-white font-bold">{t.name}</p>
                <p className="text-slate-400 text-sm">{t.role}</p>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>

        {/* Navigation */}
        <div className="flex items-center justify-center gap-4 mt-8">
          <button onClick={()=>go(-1)}
            className="w-11 h-11 rounded-full glass border border-white/[0.08] hover:border-violet-500/40 flex items-center justify-center text-slate-400 hover:text-white transition-all">
            <HiChevronLeft size={20}/>
          </button>
          {TESTIMONIALS.map((_,i) => (
            <button key={i} onClick={()=>{ setDir(i>cur?1:-1); setCur(i); }}
              className={`rounded-full transition-all duration-300 ${
                i===cur ? 'w-8 h-2 bg-violet-500' : 'w-2 h-2 bg-white/20 hover:bg-white/40'
              }`}
            />
          ))}
          <button onClick={()=>go(1)}
            className="w-11 h-11 rounded-full glass border border-white/[0.08] hover:border-violet-500/40 flex items-center justify-center text-slate-400 hover:text-white transition-all">
            <HiChevronRight size={20}/>
          </button>
        </div>

        {/* Mini cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
          {TESTIMONIALS.map((tt,i) => (
            <motion.button key={tt.name}
              onClick={()=>{ setDir(i>cur?1:-1); setCur(i); }}
              whileHover={{scale:1.04,y:-3}}
              className={`glass rounded-2xl p-4 text-left border transition-all duration-300 ${
                i===cur ? 'border-violet-500/40 bg-violet-500/5' : 'border-white/[0.06] hover:border-violet-500/20'
              }`}
            >
              <div className="flex items-center gap-3 mb-2">
                <div className={`w-9 h-9 rounded-full bg-gradient-to-br ${tt.grad} flex items-center justify-center text-white text-xs font-bold`}>{tt.init}</div>
                <div>
                  <p className="text-white text-xs font-semibold">{tt.name}</p>
                  <div className="flex gap-0.5">{[...Array(tt.rating)].map((_,j)=><FaStar key={j} className="text-amber-400" size={9}/>)}</div>
                </div>
              </div>
              <p className="text-slate-500 text-xs line-clamp-2">{tt.text}</p>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
